export const DOWNLOADS_LIMIT = 5;
export const EXTRA_DOWNLOADS_LIMIT = 20;
export const PART_PREMIUM_LIMIT = 50;
